module.exports = __webpack_public_path__ + "static/media/fly0227.177d3774.webp";